var $fa75c0154a574a1b$exports = {};
const $fa75c0154a574a1b$var$CALENDAR_WEEKS = 4;
const $fa75c0154a574a1b$var$tableElement = document.querySelector('#table');
const $fa75c0154a574a1b$var$tbodyElement = document.querySelector('#tbody');
const $fa75c0154a574a1b$var$scheduleSelect = document.querySelector('#schedule-select');
const $fa75c0154a574a1b$var$dateSelect = document.querySelector('#date-select');
const $fa75c0154a574a1b$var$calendarTable = document.querySelector('#calendar-table');
let $fa75c0154a574a1b$var$schedules = {};
let $fa75c0154a574a1b$var$currentSchedule = {};
getel('today').addEventListener('click', ()=>{
    $fa75c0154a574a1b$var$dateSelect.value = date_to_string(current_date(), false);
    $fa75c0154a574a1b$var$getDate($fa75c0154a574a1b$var$dateSelect.value);
});
getel('previous').addEventListener('click', ()=>{
    $fa75c0154a574a1b$var$dateSelect.valueAsDate = new Date($fa75c0154a574a1b$var$dateSelect.valueAsDate.getTime() - 86400000);
    $fa75c0154a574a1b$var$getDate($fa75c0154a574a1b$var$dateSelect.value);
});
getel('next').addEventListener('click', ()=>{
    $fa75c0154a574a1b$var$dateSelect.valueAsDate = new Date($fa75c0154a574a1b$var$dateSelect.valueAsDate.getTime() + 86400000);
    $fa75c0154a574a1b$var$getDate($fa75c0154a574a1b$var$dateSelect.value);
});
async function $fa75c0154a574a1b$var$getDate(date = current_date(), setCurrent = false) {
    const dateString = typeof date === 'string' ? date : date_to_string(date, false);
    const day = await get(`/api/v1/on/${dateString}`);
    if (!day) return;
    place_boxes(day, typeof date === 'string' ? date_string_to_date(date, true) : date, true, setCurrent || dateString === date_to_string(current_date(), false));
    if (setCurrent) $fa75c0154a574a1b$var$currentSchedule = day;
    for (const option of $fa75c0154a574a1b$var$scheduleSelect.querySelectorAll('option'))if (option.textContent === day.friendly_name) option.selected = true;
}
let $fa75c0154a574a1b$var$scheduleArray = [];
function $fa75c0154a574a1b$var$setScheduleValue(code) {
    $fa75c0154a574a1b$var$scheduleSelect.innerHTML = '';
    for (const schedule of $fa75c0154a574a1b$var$scheduleArray.filter((x)=>!x.hide || code === x.code)){
        const option = document.createElement('option');
        option.value = schedule.code;
        if (code === schedule.code) option.selected = true;
        if (schedule.hide || schedule.periods.length === 0) option.disabled = true;
        option.innerHTML = schedule.friendly_name;
        $fa75c0154a574a1b$var$scheduleSelect.append(option);
    }
}
async function $fa75c0154a574a1b$var$getSchedules() {
    const today = await get('/api/v1/spec');
    if (!today) return;
    $fa75c0154a574a1b$var$schedules = today.schedule_types;
    $fa75c0154a574a1b$var$scheduleSelect.innerHTML = '<option value="" disabled selected>Select a Schedule</option>';
    $fa75c0154a574a1b$var$scheduleArray = Object.keys($fa75c0154a574a1b$var$schedules).map((x)=>Object.assign({
            code: x
        }, $fa75c0154a574a1b$var$schedules[x])).sort((a, b)=>{
        if (!a.hide && b.hide || a.periods.length === 0) return 1;
        if (a.hide && !b.hide || b.periods.length === 0) return -1;
        return a.friendly_name.localeCompare(b.friendly_name);
    });
    const currentScheduleCode = $fa75c0154a574a1b$var$currentSchedule && $fa75c0154a574a1b$var$scheduleArray.find((x)=>x.friendly_name === $fa75c0154a574a1b$var$currentSchedule.friendly_name)?.code || null;
    $fa75c0154a574a1b$var$setScheduleValue(currentScheduleCode);
}
async function $fa75c0154a574a1b$var$getScheduleList(start, end) {
    const scheduleList = await get(`/api/v1/schedule/from/${date_to_string(start, false)}/to/${date_to_string(end, false)}`);
    if (!$fa75c0154a574a1b$var$schedules) return;
    const days = scheduleList.map((scheduleCode, i)=>{
        const date = new Date(start);
        date.setDate(date.getDate() + i);
        let schedule = $fa75c0154a574a1b$var$schedules[scheduleCode] || null;
        if (!schedule) try {
            schedule = JSON.parse(scheduleCode);
        } catch  {}
        const name = schedule?.friendly_name || null;
        const backgroundColor = schedule?.color ? bytes_to_color(schedule.color) : '#FFFFFF';
        const textColor = black_or_white(backgroundColor);
        return {
            code: scheduleCode,
            data: schedule,
            name: name,
            date: date,
            backgroundColor: backgroundColor,
            textColor: textColor
        };
    });
    return days;
}
$fa75c0154a574a1b$var$scheduleSelect.addEventListener('change', ()=>{
    const selected = $fa75c0154a574a1b$var$scheduleSelect.value;
    if ($fa75c0154a574a1b$var$schedules[selected]) place_boxes($fa75c0154a574a1b$var$schedules[selected], current_date(), true, $fa75c0154a574a1b$var$scheduleSelect.options[$fa75c0154a574a1b$var$scheduleSelect.selectedIndex].text === $fa75c0154a574a1b$var$currentSchedule.friendly_name);
});
$fa75c0154a574a1b$var$dateSelect.value = date_to_string(current_date(), false);
$fa75c0154a574a1b$var$dateSelect.addEventListener('change', ()=>{
    $fa75c0154a574a1b$var$getDate($fa75c0154a574a1b$var$dateSelect.value);
});
const $fa75c0154a574a1b$var$startOfWeek = current_date();
$fa75c0154a574a1b$var$startOfWeek.setHours(0, 0, 0, 0);
$fa75c0154a574a1b$var$startOfWeek.setDate($fa75c0154a574a1b$var$startOfWeek.getDate() - $fa75c0154a574a1b$var$startOfWeek.getDay());
const $fa75c0154a574a1b$var$endOfNextWeek = new Date($fa75c0154a574a1b$var$startOfWeek);
$fa75c0154a574a1b$var$endOfNextWeek.setDate($fa75c0154a574a1b$var$endOfNextWeek.getDate() + $fa75c0154a574a1b$var$CALENDAR_WEEKS * 7);
$fa75c0154a574a1b$var$dateSelect.min = date_to_string($fa75c0154a574a1b$var$startOfWeek, false);
$fa75c0154a574a1b$var$dateSelect.max = date_to_string(new Date($fa75c0154a574a1b$var$endOfNextWeek.getTime() - 86400), false);
(async ()=>{
    await $fa75c0154a574a1b$var$getDate(current_date(), true);
    await $fa75c0154a574a1b$var$getSchedules();
    const scheduleList = await $fa75c0154a574a1b$var$getScheduleList($fa75c0154a574a1b$var$startOfWeek, $fa75c0154a574a1b$var$endOfNextWeek);
    $fa75c0154a574a1b$var$calendarTable.innerHTML = '';
    const table = document.createElement('table');
    const tbody = document.createElement('tbody');
    let index = 0;
    for(let row = 0; row < $fa75c0154a574a1b$var$CALENDAR_WEEKS; row++){
        const tr = document.createElement('tr');
        for(let col = 0; col < 7; col++){
            const td = document.createElement('td');
            const day = scheduleList[index];
            const humanDate = day.date.toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'long',
                day: 'numeric'
            });
            td.classList.add('day');
            td.innerHTML = `<span class="day-name">${humanDate}</span><div class="day-schedule">${day.name}</div>`;
            if (day.date.toLocaleDateString() === current_date().toLocaleDateString()) td.classList.add('today');
            td.querySelector('.day-schedule').style.backgroundColor = day.backgroundColor;
            td.querySelector('.day-schedule').style.color = day.textColor;
            if (day.data.periods.length === 0) td.classList.add('no-periods');
            else td.addEventListener('click', ()=>{
                place_boxes(day.data, day.date, true, day.date.toLocaleDateString() === current_date().toLocaleDateString());
                $fa75c0154a574a1b$var$setScheduleValue(day.code);
                $fa75c0154a574a1b$var$dateSelect.value = date_to_string(day.date);
            });
            tr.append(td);
            index++;
        }
        tbody.append(tr);
    }
    table.append(tbody);
    $fa75c0154a574a1b$var$calendarTable.append(table);
})();


//# sourceMappingURL=schedule.8ab0a889.js.map
